// utils/useSendMessage.js - Reusable custom hook
import { useCallback } from "react";
import { sendMessage } from "../components/Header/Data";
import { useSocket } from "../contexts/SocketContext";

const useSendMessage = () => {
    const { sendNewMessage } = useSocket();
  const send = useCallback(
    async (messageForm) => {
      try {
        const response = await sendMessage(messageForm);
        if (response?.Data) {
          sendNewMessage(response.Data);
        }
        return response;
      } catch (error) {
        console.error("Failed to send message:", error);
        throw error;
      }
    },
    [sendNewMessage],
  );

  return send;
};

export default useSendMessage;
